import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts/highstock';
import * as moment from 'moment';

@Component({
  selector: 'app-industry-line-chart',
  templateUrl: './industry-line-chart.component.html',
  styleUrls: ['./industry-line-chart.component.css']
})
export class IndustryLineChartComponent implements OnInit {

  statusWiseIndChart: Chart;
  getVendorLoader = false;
  route = '';
  statusWiseIndustry = [];
  vendorList = [];
  industryCount = [];
  graphPlot = false;
  userData:any = [];
  userName = null;
  userLevel = null;
  vendor_id = 0;

  constructor(private router: Router, private _service: CommonService) { }


  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];

      if(this.userLevel == 'vendor'){
        this.vendor_id = this.userData['id'];
      }

    }

    this.getStatusWiseIndustry();
  }

  getStatusWiseIndustry(){

    this.getVendorLoader = true;
    this.route  = 'get-status-wise-industry';
    const token    = localStorage.getItem('userToken');
    this.graphPlot = false;

    let data = {};

    if(this.userLevel == 'vendor'){
      data = {'user_id':this.userName,'user_level':this.userLevel, 'vendor_id':this.vendor_id};
    }else {
      data = {'user_id':this.userName,'user_level':this.userLevel};
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.getVendorLoader = false;
        var color = '';

        for(let status in response.data) {
          if(status == 'Online'){
            color = '#85CA47';
          }else if(status == 'Delay'){
            color = '#FF7417';
          }else{
            color = '#FF0000';
          }

          if(response.data[status]){
            this.graphPlot = true;
          }

          this.statusWiseIndustry.push({'name':status,'y':response.data[status], 'color':color });
        };

        if(this.graphPlot){
          this.drawVendorWiseIndGraph(this.statusWiseIndustry);
        }else{
          this.getVendorLoader = false;
        }
      }
    });

  }

  drawVendorWiseIndGraph(statusList){

    let barChartLocal = new Chart({
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          }
        }
      },
      series: [{
        name: 'Industries',
        data: statusList,
        type: 'pie',

      }]
    });
    this.statusWiseIndChart = barChartLocal;

    this.getVendorLoader = false;
  }

}
